import { useQuery } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { getBusinessSmsTemplates } from '../../services/marketing';

interface Options {
  enabled?: boolean;
  onSuccess?: (
    result: Awaited<ReturnType<typeof getBusinessSmsTemplates>>,
  ) => void | Promise<void>;
}

function useGetSmsTemplates({ enabled = true, onSuccess }: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();

  const { data, isFetching, isLoading, isError, error, refetch } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['marketing-sms-templates', marketingData?.id],
    queryFn: async () => {
      const result = await getBusinessSmsTemplates(marketingData?.id!);

      if (result && onSuccess) {
        await onSuccess(result);
      }

      return result;
    },
    enabled:
      !!marketingData?.id && !isFetchingMarketing && isEnabled && enabled,
  });

  return {
    data,
    isFetching,
    isLoading,
    isError,
    error,
    refetch,
  };
}

export default useGetSmsTemplates;
